<template>
  <UsersTable />
</template>

<script>
import UsersTable from "./UsersTable.vue";

export default {
  components: {
    UsersTable,
  },
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  watch: {},
  computed: {},
};
</script>
